import axios from 'axios'
import { url, endPoint } from '../urls'

export const addIcon = (params) => {
  let _url = url.backendHost + endPoint.icon.addIcon
  return axios.post(_url, params)
}

export const getIconsList = (params) => {
  let _url = url.backendHost + endPoint.icon.getIconList
  return axios.get(_url, { params })
}